import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import PrivateRoute from './components/PrivateRoute';
import Login from './components/Auth/LearnerLoginCard';
import ForgotPassword from './components/Auth/ForgotPasswordAuthCard';
import ResetPassword from './components/Auth/ResetPasswordAuthCard';
import Activation from './components/Auth/Activation';
import MagicLinkActivation from './components/Auth/MagicLinkActivation';
import Dashboard from './components/Dashboard/Dashboard';
import UserProfile from './components/User/UserProfile';
import ChangePassword from './components/Auth/ChangePassword';
import Layout from './components/Layout/Layout';
import Notifications from './components/Notifications/Notifications';
import Users from './components/User/Users';
import ActiveFields from './components/User/ActiveFields';
import Groups from './components/User/Groups';
import AssignmentsList from './components/Assignments/AssignmentsList';
import AssignmentForm from './components/Assignments/AssignmentForm';
import AssignmentPreview from './components/Assignments/AssignmentPreview';
import AssignmentSubmitForm from './components/Assignments/AssignmentSubmitForm';
import CoursesGrid from './components/Course/CoursesGrid';
import CourseForm from './components/Course/CourseForm';
import CourseSettings from './components/Course/CourseSettings';
import CoursePreview from './components/Course/CoursePreview';
import ContentsList from './components/Contents/ContentsList';
import ContentForm from './components/Contents/ContentForm';
import AddContent from './components/Contents/AddContent';
import InstanceList from './components/common/InstanceList';
import FeedbackSettings from './components/Settings/FeedbackSettings';
import EmailTemplates from './components/Settings/EmailTemplates';
import InstanceFeedbackSettings from './components/Settings/InstanceFeedbackSettings';
import DefaultFeedbackSettings from './components/Settings/DefaultFeedbackSettings';
import CourseEmailTemplate from './components/Settings/CourseEmailTemplate';
import LearningPathEmailTemplate from './components/Settings/LearningPathEmailTemplate';
import CourseLearners from './components/Course/Learners';
import L1Feedback from './components/Course/L1Feedback';
import ContentPlayer from './components/Player/ContentPlayer';
import { ContentPlayerProvider } from './context/ContentPlayerContext';
import LPathGrid from './components/LearningPath/LPathGrid'
import LPathForm from './components/LearningPath/LPathForm';
import LPathSettings from './components/LearningPath/LPathSettings';
import LPathLearners from './components/LearningPath/LPathLearners';
import LearningPathPreview from './components/LearningPath/LearningPathPreview';
import LPathL1Feedback from './components/LearningPath/LPathL1Feedback';
import Catlog from './components/Learner/Catlog';
import GeneralSettings from './components/Settings/GeneralSettings';
import EmbedSettings from './components/Settings/EmbedSettings';

import LPathContentSelector from './components/LearningPath/LPathContentSelector';
import { ThemeProvider } from '@mui/material';
// THEME: use the single design-system theme (src/theme.js). The former inline
// createTheme (blue #0a60fe, Inter, cool greys) shadowed it and was removed.
// If anything imported `colors` from this file, that export is gone — colours
// live in the theme/tokens now.
import theme from './theme';

import CssBaseline from '@mui/material/CssBaseline';

import { UserProvider } from './context/UserContext';
import { NotificationProvider } from './context/NotificationContext';
import { LoaderProvider, useLoader } from './context/LoaderContext';
import { setupLoaderInterceptors } from './services/api';

import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { ToastProvider } from './context/ToastContext';
import IndependentLayout from './components/Layout/IndependentLayout';
import EmbeddedRoutes from './components/Embedded/EmbeddedRoutes';
//Questions
import QuizList from './components/Quiz/QuizList';
import QuizForm from './components/Quiz/QuizForm';
import QuestionsList from './components/Questions/QuestionsList';
import QuestionForm from './components/Questions/QuestionForm';
import { useNotifications } from './context/NotificationContext';
import NominationPopup from './components/Notifications/NominationPopup';
import MyLearnings from './components/Learner/MyLearnings';
import QuizPreview from './components/Quiz/QuizPreview';
import QuizStart from './components/Quiz/QuizStart';
import QuestionDisplay from './components/Quiz/QuestionDisplay';
import ViewResult from './components/Quiz/ViewResult';
import ResultDetails from './components/Quiz/ResultDetails'
import RoleBasedRoute from './components/RoleBasedRoute';
import AssignmentSubmission from './components/Assignments/AssignmentSubmission';
import AssignmentRank from './components/Assignments/AssignmentRank';
import QuizSubmission from './components/Quiz/QuizSubmission';
import QuizRank from './components/Quiz/QuizRank';
import AllInstances from './components/Course/AllInstances';
import LearningPathLearnerView from './components/LearningPath/LearningPathLearnerView';
import AllLPathInstances from './components/LearningPath/AllLPathInstances';
import StudentGrade from './components/Assignments/StudentGrade';
import LearnerGrade from './components/Quiz/LearnerGrade';
import FeedbackModal from './components/Feedback/FeedbackModal';
import LearningSum from './components/Dashboard/LearningSummary';
import PurgeUsers from './components/User/PurgeUsers';
import Skills from './components/Skills/Skills';
import JobRoles from './components/User/JobRoles';
import JobRoleForm from './components/User/JobRoleForm';


//Migeration
import MigrationDashboard from './components/Migration/MigrationDashboard';
import MigrationFileUpload from './components/Migration/MigrationFileUpload';
import MigrationMapping from './components/Migration/MigrationMapping';
import MigrationConfiguration from './components/Migration/MigrationConfiguration';
import MigrationProcessing from './components/Migration/MigrationProcessing';
import MigrationReports from './components/Migration/MigrationReports';
import MigrationHistory from './components/Migration/MigrationHistory';
import MigrationSessionDetails from './components/Migration/MigrationSessionDetails';
import MigrationTemplates from './components/Migration/MigrationTemplates';

import JobAidsForm from './components/JobAids/JobAidsForm';
import JobAid from './components/JobAids/JobAid';
import JobAidPlayer  from './components/JobAids/JobAidPlayer';
import AllRecommendations from './components/Learner/AllRecommendations';

//Certificate
import Certificate from './components/Certificates/Certificate';
import CertificateForm from './components/Certificates/CertificateForm';
import CertificateCourseSelector from './components/Certificates/CertificateCourseSelector';
import CertificatePreview  from './components/Certificates/CertificatePreview';
//Reports
import LearnerProgressReport from './components/Reports/LearnerProgress/LearnerProgressReport';
import SkillGraphSummaryReport from './components/Reports/SkillGraphSummary/SkillGraphSummaryReport';
import CourseEngagementReport from './components/Reports/CourseEngagement/CourseEngagementReport';
import JobRoleReadinessReport from './components/Reports/JobRoleReadiness/JobRoleReadinessReport';
import SkillsAndRolesReport from './components/Reports/SkillsAndRolesReport';
import ReportsDashboard from './components/Reports/Dashboard/ReportsDashboard';
import SearchInsightsReport from './components/Reports/SearchInsights/SearchInsightsReport';
import ComplianceReport from './components/Reports/Compliance/ComplianceReport';
import ActiveUsersReport from './components/Dashboard/ActiveUsersReport';

// Insights feature
import InsightsDashboard from './components/Insights/InsightsDashboard';
import SearchIntelligence from './components/Insights/SearchIntelligence';
import ContentHealth from './components/Insights/ContentHealth';
// Removed 12 Oct 2026 (N5 pt 22): the Learner Health import; the page is switched off for v1 (K12 rule).

//Bookmark course
import FavoriteCourses from './components/Learner/FavoriteCourses';
import RecentContent from './components/Learner/RecentContent';

import SelfSignup from './components/Auth/SelfSignup';
import SelfSignupActivation from './components/Auth/SelfSignupActivation';
import LearnerLoginCard from './components/Auth/LearnerLoginCard';
import ForgotPasswordAuthCard from './components/Auth/ForgotPasswordAuthCard';
import ResetPasswordAuthCard from './components/Auth/ResetPasswordAuthCard';

//admin.beetsol.com
import ClientsAdminForm from './components/Clients/ClientsAdminForm';
import ClientsAdminList from './components/Clients/ClientsAdminList';
import TrialSignupForm from './components/Clients/TrialSignupForm';

// ErrorBoundary for the Insights pages — turns a runtime failure into a
// readable message instead of a blank screen.
class PageErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { error: null, info: null }; }
  static getDerivedStateFromError(error) { return { error }; }
  componentDidCatch(error, info) { this.setState({ info }); console.error('[PageErrorBoundary]', this.props.name, error, info); }
  render() {
    if (this.state.error) {
      return (
        <div style={{ padding: '32px', fontFamily: '"DM Sans", sans-serif' }}>
          <div style={{ fontSize: '15px', fontWeight: 500, color: '#111110', marginBottom: '8px' }}>
            {this.props.name || 'This page'} hit an error while rendering.
          </div>
          <pre style={{ fontSize: '12px', background: '#F7F7F6', border: '0.5px solid #E8E8E6', borderRadius: '8px', padding: '14px', whiteSpace: 'pre-wrap', color: '#A32D2D' }}>
            {String(this.state.error && (this.state.error.stack || this.state.error.message || this.state.error))}
            {this.state.info ? '\n\nComponent stack:' + this.state.info.componentStack : ''}
          </pre>
        </div>
      );
    }
    return this.props.children;
  }
}



function AppContent() {
  const { startLoader, stopLoader } = useLoader();
  const {
    showNominationPopup,
    closeNominationPopup,
    currentNominationId,
    // Add feedback popup state and functions
    showFeedbackPopup,
    feedbackData,
    closeFeedbackPopup
  } = useNotifications();

  useEffect(() => {
    setupLoaderInterceptors(startLoader, stopLoader);
  }, [startLoader, stopLoader]);

  // Removed 23 Oct 2026 (K11 pt 5.1): a /login route for the admin site written outside <Routes>, which never ran. The
  // admin site opens on Workspaces after sign-in (LearnerLoginCard) and its menu links to it (Sidebar).

  return (
    <BrowserRouter>
      <Routes>
        {/* Workspace slugs — dynamic. Slugs are provisioned at admin.beetsol.com;
            clients use app.beetsol.com/learn/{slug} and /signup/{slug}. One route
            each via :slug param (NOT one hardcoded route per workspace). */}
        <Route path="/learn/:slug" element={<Login />} />
        <Route path="/signup/:slug" element={<SelfSignup />} />
        {/* Workspace slugs end */}  
        <Route path="/forgot" element={<ForgotPasswordAuthCard />} />
        <Route path="/reset/:token" element={<ResetPasswordAuthCard />} />      
        <Route path="/self-signup-activate/:token" element={<SelfSignupActivation />} />
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset_password/:token" element={<ResetPassword />} />
        <Route path="/set-password/:token" element={<ResetPassword />} />
        <Route path="/activate/:token" element={<Activation />} />
        <Route path="/magic-link/:token" element={<MagicLinkActivation />} />
        <Route path="/trial-signup" element={<TrialSignupForm />} />
        
        
        {/* Independent layout routes (no header, sidebar, footer) */}
        <Route element={<IndependentLayout />}>
          <Route path="/assignments/preview/:assignment_id/:courseId/:ccrId" element={<AssignmentPreview />} />
          <Route path="/assignments/preview/:assignment_id" element={<AssignmentPreview />} />
          <Route path="/assignments/submit/:assignment_id/:courseId/:ccrId" element={<AssignmentSubmitForm />} />
          <Route path="/assignments/submit/:assignment_id" element={<AssignmentSubmitForm />} />
          <Route path="/course/preview/:id/standalone" element={<CoursePreview />} />
          <Route path="/learning_path/preview/:id/standalone" element={<LearningPathPreview />} />
          <Route path="/quiz/preview/:quizId/:courseId/:ccrId" element={<QuizPreview />} />
          <Route path="/quiz/start/:quizId/:courseId/:ccrId" element={<QuizStart />} />
          <Route path="/quiz/question/:quizId/:courseId/:ccrId" element={<QuestionDisplay />} />
          <Route path="/quiz/preview/:quizId" element={<QuizPreview />} />
          <Route path="/quiz/result/:quizId" element={<ViewResult />} />
          <Route path="/quiz/result-details/:quiz_id" element={<ResultDetails />} />
          <Route path="/job-aids/preview/:id" element={<RoleBasedRoute element={<JobAidPlayer isLearnerMode={true} />} allowedRoles={['author','admin','learner']}  />} />
          {/* Migration Routes - Admin and Author access */}
          {/*}
          <Route path="/migration" element={<RoleBasedRoute element={<MigrationDashboard />} allowedRoles={['admin', 'author']} />} />
          <Route path="/migration/dashboard" element={<RoleBasedRoute element={<MigrationDashboard />} allowedRoles={['admin', 'author']} />} />
          <Route path="/migration/upload/:sessionId" element={<RoleBasedRoute element={<MigrationFileUpload />} allowedRoles={['admin', 'author']} />} />
          <Route path="/migration/mapping/:sessionId" element={<RoleBasedRoute element={<MigrationMapping />} allowedRoles={['admin', 'author']} />} />
          <Route path="/migration/configuration/:sessionId" element={<RoleBasedRoute element={<MigrationConfiguration />} allowedRoles={['admin', 'author']} />} />
          <Route path="/migration/processing/:sessionId" element={<RoleBasedRoute element={<MigrationProcessing />} allowedRoles={['admin', 'author']} />} />
          <Route path="/migration/reports" element={<RoleBasedRoute element={<MigrationReports />} allowedRoles={['admin', 'author']} />} />
          <Route path="/migration/reports/:sessionId" element={<RoleBasedRoute element={<MigrationReports />} allowedRoles={['admin', 'author']} />} />
          <Route path="/migration/history" element={<RoleBasedRoute element={<MigrationHistory />} allowedRoles={['admin', 'author']} />} />
          <Route path="/migration/sessions/:sessionId" element={<RoleBasedRoute element={<MigrationSessionDetails />} allowedRoles={['admin', 'author']} />} />
          <Route path="/migration/templates" element={<RoleBasedRoute element={<MigrationTemplates />} allowedRoles={['admin', 'author']} />} />
          */}
          {/* Admin Setup Routes */}
          <Route path="/workspace/create" element={<ClientsAdminForm />} />
          <Route path="/workspace/edit/:clientId" element={<ClientsAdminForm />} />
          <Route path="/workspace" element={<ClientsAdminList />} />
        </Route>
        {/* Embedded routes */}
        <Route path="/embed/*" element={<EmbeddedRoutes />} />
        <Route
          path="/courses/:courseId/content/:contentId"
          element={
            <ContentPlayerProvider>
              <ContentPlayer />
            </ContentPlayerProvider>
          }
        />
        {/* Independent layout End */}

        <Route element={<PrivateRoute />}>
          <Route element={<Layout />}>
            {/* Common routes accessible to all authenticated users */}
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/users/profile" element={<UserProfile />} />
            <Route path="/auth/change-password" element={<ChangePassword />} />
            <Route path="/notifications" element={<Notifications />} />
            <Route path="/course/preview/:id" element={<CoursePreview />} />
            <Route path="/course/:id/instance/:instanceId" element={<CoursePreview />} />
            <Route path="/learning_path/preview/:id" element={<LearningPathPreview />} />
            <Route path="/learning_path/preview/:id/:instanceId" element={<LearningPathPreview />} />

            {/* admin only Routes  */}
            <Route path="/users" element={<RoleBasedRoute element={<Users />} allowedRoles={['admin']} />} />
            <Route path="/users/purge" element={<RoleBasedRoute element={<PurgeUsers />} allowedRoles={['admin']} />} />
            <Route path="/groups" element={<RoleBasedRoute element={<Groups />} allowedRoles={['admin']} />} />
            {/*}
            <Route path="/active-fields" element={<RoleBasedRoute element={<ActiveFields />} allowedRoles={['admin']} />} />
            */}
            <Route path="/job-roles" element={<RoleBasedRoute element={<JobRoles />} allowedRoles={['admin']} />} />
            <Route path="/job-roles/form" element={<RoleBasedRoute element={<JobRoleForm />} allowedRoles={['admin']} />} />
            <Route path="/job-roles/form/:id" element={<RoleBasedRoute element={<JobRoleForm />} allowedRoles={['admin']} />} />
            
            <Route path="/settings/feedback" element={<RoleBasedRoute element={<FeedbackSettings />} allowedRoles={['admin']} />} />
            <Route path="/settings/emailSettings" element={<RoleBasedRoute element={<EmailTemplates />} allowedRoles={['admin']} />} />
            <Route path="/settings/feedback-settings/:id" element={<RoleBasedRoute element={<DefaultFeedbackSettings isLearningPath={false} />} allowedRoles={['admin']} />} />
            <Route path="/learning_path/feedback-settings/:id" element={<RoleBasedRoute element={<DefaultFeedbackSettings isLearningPath={true} />} allowedRoles={['admin']} />} />
            <Route path="/course/feedback-settings/:id/:instanceId" element={<RoleBasedRoute element={<InstanceFeedbackSettings isLearningPath={false} />} allowedRoles={['admin']} />} />
            <Route path="/learning_path/feedback-settings/:id/:instanceId" element={<RoleBasedRoute element={<InstanceFeedbackSettings isLearningPath={true} />} allowedRoles={['admin']} />} />
            <Route path="/settings/generalSettings" element={<RoleBasedRoute element={<GeneralSettings />} allowedRoles={['admin']} />} />
            <Route path="/skills" element={<RoleBasedRoute element={<Skills />} allowedRoles={['admin']} />} />
            <Route path="/settings/embedded" element={<RoleBasedRoute element={<EmbedSettings />} allowedRoles={['admin']} />} />
            <Route path="/reports/learner-progress" element={<RoleBasedRoute element={<LearnerProgressReport />} allowedRoles={['admin']} />} />
            {/*<Route path="/reports/skill-graph-summary" element={<RoleBasedRoute element={<SkillGraphSummaryReport />} allowedRoles={['admin']} />} />*/}
            <Route path="/reports/course-engagement" element={<RoleBasedRoute element={<CourseEngagementReport />} allowedRoles={['admin']} />} />
            {/*<Route path="/reports/job-role-readiness" element={<RoleBasedRoute element={<JobRoleReadinessReport />} allowedRoles={['admin']} />} />
            <Route path="/reports/skills-and-roles" element={<RoleBasedRoute element={<SkillsAndRolesReport />} allowedRoles={['admin']} />} />*/}
            <Route path="/reports/dashboard" element={<RoleBasedRoute element={<ReportsDashboard />} allowedRoles={['admin']} />} />
            <Route path="/reports/search-insights" element={<RoleBasedRoute element={<SearchInsightsReport />} allowedRoles={['admin']} />} />
            <Route path="/reports/compliance" element={<RoleBasedRoute element={<ComplianceReport />} allowedRoles={['admin']} />} />
            <Route path="/reports/active-users" element={<RoleBasedRoute element={<ActiveUsersReport />} allowedRoles={['admin']} />} />

            {/* Insights Dashboard */}
            {/* Insights are for admins only, as the menu is (S-27). Removed 11 Oct 2026 (S-27): opening them for authors and the removed manager role. */}
            <Route path="/insights" element={<RoleBasedRoute element={<PageErrorBoundary name="Insights Dashboard"><InsightsDashboard /></PageErrorBoundary>} allowedRoles={['admin']} />} />
            <Route path="/insights/search-intelligence" element={<RoleBasedRoute element={<PageErrorBoundary name="Search Intelligence"><SearchIntelligence /></PageErrorBoundary>} allowedRoles={['admin']} />} />
            <Route path="/insights/content-health" element={<RoleBasedRoute element={<PageErrorBoundary name="Content Health"><ContentHealth /></PageErrorBoundary>} allowedRoles={['admin']} />} />
            {/* Removed 12 Oct 2026 (N5 pt 22): the /insights/learner-health route. Learner Health is switched off for v1
                (parked as per-learner activity, PK13); activity per person is on the Usage page (N45). */}
            <Route path="/insights/compliance" element={<RoleBasedRoute element={<PageErrorBoundary name="Compliance"> <ComplianceReport /></PageErrorBoundary>}allowedRoles={['admin']} /> }/>
            {/* author,Manager and admin routes */}
            <Route path="/courses" element={<RoleBasedRoute element={<CoursesGrid />} allowedRoles={['admin', 'author', 'manager']} />} />
            {/*
            <Route path="/assignments" element={<AssignmentsList />} />
            <Route path="/assignments/form/:id" element={<AssignmentForm />} />
            <Route path="/assignments/form" element={<AssignmentForm />} />
            */}

            {/*<Route path="/course/instances/:id" element={<RoleBasedRoute element={<InstanceList isLearningPath={false} />} allowedRoles={['admin', 'author']} />} />*/}
            <Route path="/learning_path/" element={<RoleBasedRoute element={<LPathGrid />} allowedRoles={['admin', 'author','manager']} />} />
            <Route path="/learning_path/form" element={<RoleBasedRoute element={<LPathForm />} allowedRoles={['admin', 'author']} />} />
            <Route path="/learning_path/form/:id" element={<RoleBasedRoute element={<LPathForm />} allowedRoles={['admin', 'author']} />} />
            <Route path="/learning_path/settings/:id" element={<RoleBasedRoute element={<LPathSettings />} allowedRoles={['admin', 'author']} />} />
            {/*<Route path="/learning_path/instances/:id" element={<RoleBasedRoute element={<InstanceList isLearningPath={true} />} allowedRoles={['admin', 'author']} />} />*/}
            <Route path="/learning_path/learners/:id" element={<RoleBasedRoute element={<LPathLearners />} allowedRoles={['admin', 'manager']} />} />
            <Route path="/learning_path/learners/:id/:instanceId" element={<RoleBasedRoute element={<LPathLearners />} allowedRoles={['admin', 'manager']} />} />
            <Route path="/learning_path/contents/:id" element={<RoleBasedRoute element={<LPathContentSelector />} allowedRoles={['admin', 'author']} />} />
            <Route path="/settings/email-template/:id" element={<RoleBasedRoute element={<CourseEmailTemplate />} allowedRoles={['admin', 'author']} />} />
            <Route path="/settings/lp-email-template/:id" element={<RoleBasedRoute element={<LearningPathEmailTemplate />} allowedRoles={['admin', 'author']} />} />
            <Route path="/course/learners/:id" element={<RoleBasedRoute element={<CourseLearners />} allowedRoles={['admin', 'manager']} />} />
            <Route path="/course/learners/:id/:instanceId" element={<RoleBasedRoute element={<CourseLearners />} allowedRoles={['admin', 'manager']} />} />
            <Route path="/course/l1-feedback/:id" element={<RoleBasedRoute element={<L1Feedback />} allowedRoles={['admin', 'manager']} />} />
            <Route path="/learning_path/l1-feedback/:id" element={<RoleBasedRoute element={<LPathL1Feedback />} allowedRoles={['admin', 'manager']} />} />

            {/* author only routes */}
            <Route path="/course/form/:id" element={<RoleBasedRoute element={<CourseForm />} allowedRoles={['author']} />} />
            <Route path="/course/form" element={<RoleBasedRoute element={<CourseForm />} allowedRoles={['author']} />} />
            <Route path="/course/settings/:id" element={<RoleBasedRoute element={<CourseSettings />} allowedRoles={['author']} />} />
            <Route path="/contents" element={<RoleBasedRoute element={<ContentsList />}  />} /> {/* allowedRoles={['author']} */}
            <Route path="/contents/add" element={<RoleBasedRoute element={<AddContent />} allowedRoles={['author']} />} />
            <Route path="/contents/form/:id" element={<RoleBasedRoute element={<ContentForm />} allowedRoles={['author']} />} />
            <Route path="/contents/form" element={<RoleBasedRoute element={<ContentForm />} allowedRoles={['author']} />} />
            {/*
            <Route path="/questions" element={<RoleBasedRoute element={<QuestionsList />} allowedRoles={['author']} />} />
            <Route path="/questions/form/:id" element={<RoleBasedRoute element={<QuestionForm />} allowedRoles={['author']} />} />
            <Route path="/questions/form" element={<RoleBasedRoute element={<QuestionForm />} allowedRoles={['author']} />} />
            <Route path="/quiz" element={<RoleBasedRoute element={<QuizList />} allowedRoles={['author']} />} />
            <Route path="/quiz/form/:id" element={<RoleBasedRoute element={<QuizForm />} allowedRoles={['author']} />} />
            <Route path="/quiz/form" element={<RoleBasedRoute element={<QuizForm />} allowedRoles={['author']} />} />
            <Route path="/job-aids" element={<RoleBasedRoute element={<JobAid />} allowedRoles={['author']} />} />
            <Route path="/job-aids/create" element={<RoleBasedRoute element={<JobAidsForm />} allowedRoles={['author']} />} />
            <Route path="/job-aids/edit/:id" element={<RoleBasedRoute element={<JobAidsForm />} allowedRoles={['author']} />} />
            
            <Route path="/certificates" element={<RoleBasedRoute element={<Certificate />} allowedRoles={['author','admin']} />} />
            <Route path="/certificates/form/:id" element={<RoleBasedRoute element={<CertificateForm />} allowedRoles={['author']} />} />
            <Route path="/certificates/form" element={<RoleBasedRoute element={<CertificateForm />} allowedRoles={['author']} />} />
            <Route path="/certificates/create/" element={<RoleBasedRoute element={<CertificateForm />} allowedRoles={['author']} />} />
            <Route path="/certificates/update/:id" element={<RoleBasedRoute element={<CertificateForm />} allowedRoles={['author']} />} />
            <Route path="/certificates/certificate_courses" element={<RoleBasedRoute element={<CertificateCourseSelector />} allowedRoles={['author']} />} />
            <Route path="/certificates/certificate_courses/:id" element={<RoleBasedRoute element={<CertificateCourseSelector />} allowedRoles={['author']} />} />
            <Route path="/certificates/:id/catalog_courses" element={<RoleBasedRoute element={<CertificateCourseSelector />} allowedRoles={['author']} />} />
            <Route path="/certificates/preview/:id" element={<RoleBasedRoute element={<CertificatePreview />} allowedRoles={['author','admin','learner']} />} />
            */}
            {/* Manager only routes */}
            <Route path="/dashboard/learning-summary" element={
              <RoleBasedRoute element={<LearningSum />} allowedRoles={['manager']} />} />

            {/* Learners Routes  */}
            <Route path="/learner/course/:id/:instanceId" element={<RoleBasedRoute element={<CoursePreview />} allowedRoles={['learner']} />} />
            <Route path="/learner/course/:id" element={<RoleBasedRoute element={<CoursePreview />} allowedRoles={['learner']} />} />
            <Route path="/learner/my-learnings" element={<RoleBasedRoute element={<MyLearnings />} allowedRoles={['learner']} />} />
            <Route path="/learner/catalog" element={<RoleBasedRoute element={<Catlog />} allowedRoles={['learner']} />} />
            <Route path="/learner/course/:id/instances" element={<RoleBasedRoute element={<AllInstances />} allowedRoles={['learner']} />} />
            <Route path="/learner/lpath/:id/:instanceId" element={<RoleBasedRoute element={<LearningPathLearnerView />} allowedRoles={['learner']} />} />
            <Route path="/learner/lpath/:id" element={<RoleBasedRoute element={<LearningPathLearnerView />} allowedRoles={['learner']} />} />
            <Route path="/learner/lpath/:id/instances" element={<RoleBasedRoute element={<AllLPathInstances />} allowedRoles={['learner']} />} />
            <Route path="/learner/recommendations" element={<RoleBasedRoute element={<AllRecommendations />} allowedRoles={['learner']} />} />
            <Route path="/learner/favorites" element={<RoleBasedRoute element={<FavoriteCourses />} AllInstances={['learner']} />} />
            <Route path="/learner/recent-contents" element={<RoleBasedRoute element={<RecentContent />} allowedRoles={['learner']} />} />
            
            {/* Instructor Routes */}
            {/*
            <Route path="/assignments/submissions" element={<AssignmentSubmission />} />
            <Route path="/assignments/assignment_rank/:assignment_id/:course_id" element={<AssignmentRank />} />
            <Route path="/assignments/learner_grade/:assignment_id/:learner_id/:course_id" element={<StudentGrade />} />
            <Route path="/quiz/submissions" element={<QuizSubmission />} />
            <Route path="/quiz/quiz_rank/:quiz_id/:course_id" element={<QuizRank />} />
            <Route path="/quiz/learner_grade/:quiz_id/:learner_id/:course_id" element={<LearnerGrade />} />
            */}
            
          </Route>
        </Route>
        {/* Catch-all: redirect unknown URLs to home */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>

      <NominationPopup
        open={showNominationPopup}
        onClose={closeNominationPopup}
        nominationId={currentNominationId}
      />
      {showFeedbackPopup && feedbackData && (
        <FeedbackModal
          open={showFeedbackPopup}
          onClose={closeFeedbackPopup}
          itemId={feedbackData.itemId}
          enrollmentId={feedbackData.enrollmentId}
          instanceId={feedbackData.instanceId}
          itemType={feedbackData.itemType}
        />
      )}
    </BrowserRouter>
  );
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <UserProvider>
          <NotificationProvider>
            <ToastProvider>
              <LoaderProvider>
                <ContentPlayerProvider>
                  <AppContent />
                </ContentPlayerProvider>
              </LoaderProvider>
            </ToastProvider>
          </NotificationProvider>
        </UserProvider>
      </LocalizationProvider>
    </ThemeProvider>
  );
}

export default App;